import React from 'react';

interface Props {
  bg: string;
  fg: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
  onClick?: (e: React.MouseEvent<HTMLSpanElement>) => void;
  title?: string;
}

/**
 * Standard pill badge — IBM Plex Sans 9px 600 uppercase 0.06em / 2×7 / r3.
 * Used for status, severity, priority, category etc.
 */
export default function Badge({ bg, fg, children, style, onClick, title }: Props) {
  return (
    <span
      onClick={onClick}
      title={title}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        background: bg,
        color: fg,
        fontFamily: 'var(--font-ui)',
        fontSize: 9,
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        padding: '2px 7px',
        borderRadius: 3,
        whiteSpace: 'nowrap',
        cursor: onClick ? 'pointer' : 'default',
        ...style,
      }}
    >
      {children}
    </span>
  );
}
